<template v-model="">
  <v-container class="text-center" fluid>
    <login-box v-if="!$store.getters.isAuthenticated"/>
  </v-container>
</template>

<script>

import LoginBox from '../components/LoginBox';
import HOST from '../ws'

export default {

  components : {
    LoginBox
  },
  props: {
    source: String
  },
  data: () => ({
    
  }),

  beforeMount(){
    //testando se está logado:
    this.axios({
      method: "post",
      url: HOST.HOST + "/user/checktk",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.$store.state.currentToken}`
      },
    })
    .then(response => {
      console.log('logado : ' + response.status);
      
      if(this.$store.getters.isAuthenticated){
        this.$router.push("noticias");
      }else{
        this.$store.commit("logout");
        //this.$router.push("noticias");
      }
    })
    .catch(error => {
      console.log(error.message);
      this.$store.commit("logout");
    });
  },

  methods : {
    
  }
};
</script>